import { ITab } from '@framework/ui/Pages/Landing/Sections/TabsSlider/interface';

import accessVastLibrary from '../assets/accessVastLibrary.webp';
import broadenYourResearch from '../assets/broadenYourResearch.webp';
import leverageExpertPerspectives from '../assets/leverageExpertPerspectives.webp';
import runInDepthAnalyses from '../assets/runInDepthAnalyses.webp';
import keepARealTime from '../assets/keepARealTime.webp';
import exportClean from '../assets/exportClean.webp';

import IconLayersGroup from '@creditflowresearch/uilib/Icon/IconLayersGroup';
import IconMappings from '@creditflowresearch/uilib/Icon/IconMappings';
import IconStar from '@creditflowresearch/uilib/Icon/IconStar';
import IconAnalytics from '@creditflowresearch/uilib/Icon/IconAnalytics';
import IconEmailAlerts from '@creditflowresearch/uilib/Icon/IconEmailAlerts';
import IconFileXls from '@creditflowresearch/uilib/Icon/IconFileXls';

export const sectionOne: ITab[] = [
  {
    key: 'accessVastLibrary',
    icon: IconLayersGroup,
    title: 'Access the world’s leading new issue pricing database in US fixed income',
    description: (
      <p>
        CreditFlow maintains the world’s leading new issue database of +100,000 pricings.
      </p>
    ),
    img: {
      src: accessVastLibrary.src,
      width: 1420,
      height: 896,
      key: 1,
    },
    imgLabel: 'CreditFlow’s market data dropdown provides an overview of coverage across tools, regions, sectors and industries.',
  },
  {
    key: 'broadenYourResearch',
    icon: IconMappings,
    title: 'Expand your research with proprietary data mapping',
    description: (
      <p>
        Leverage our proprietary data mapping to monitor new issue activity by
        industry, sector, sponsor, issuer, underwriter, rating, or capital structure.
      </p>
    ),
    img: {
      src: broadenYourResearch.src,
      width: 1420,
      height: 896,
      key: 1,
    },
    imgLabel: 'Track deal or tranche level performance from mandate to secondary performance with CreditFlow’s robust data sets and intuitive data mapping.',
  },
  {
    key: 'leverageExpertPerspectives',
    icon: IconStar,
    title: 'Leverage expert perspectives with timely commentary & intelligence',
    description: (
      <p>
        CreditFlow analysts are recognized across fixed income markets for rapid delivery
        of rich and actionable commentary, custom reports and more.
      </p>
    ),
    img: {
      src: leverageExpertPerspectives.src,
      width: 1420,
      height: 896,
      key: 1,
    },
    imgLabel: 'Each deal flow and commentary article is tied to relevant deals, parents and issuers to streamline research.',
  },
];

export const sectionTwo: ITab[] = [
  {
    key: 'runInDepthAnalyses',
    icon: IconAnalytics,
    title: 'Run in-depth analyses with robust filtering & dynamic charting',
    description: (
      <p>
        CreditFlow offers dozens of filters tied to responsive charting and visualizations
        for easy trend analysis across Sectors, Industries, Broker-Dealers, Issuers and time.
      </p>
    ),
    img: {
      src: runInDepthAnalyses.src,
      width: 1420,
      height: 896,
      key: 1,
    },
    imgLabel: 'CreditFlow’s responsive charting and visualizations update based on your filter selections.',
  },
  {
    key: 'keepARealTime',
    icon: IconEmailAlerts,
    title: 'Maintain a pulse on market activity with customizable email alerts',
    description: (
      <p>
        CreditFlow email alerts are fast, customizable, and contain all the context
        required to keep you apprised of the latest new issue activity.
      </p>
    ),
    img: {
      src: keepARealTime.src,
      width: 1420,
      height: 896,
      key: 1,
    },
    imgLabel: 'Email alerts can be customized by dozens of parameters, including region, credit product, theme and more.',
  },
  {
    key: 'exportClean',
    icon: IconFileXls,
    title: 'Export clean, client-ready reports of your queries',
    description: (
      <p>
        CreditFlow offers exports of filtered data sets, new issue stats and more,
        directly from data tools and profiles in clean, client-ready Excel files.*
        <br />
        <br />
        *Bond Screener Exports are available as a paid add-on.
      </p>
    ),
    img: {
      src: exportClean.src,
      width: 1420,
      height: 896,
      key: 1,
    },
    imgLabel: 'Benchmark and analyze market performance with daily, weekly, monthly and annual Stats.',
  },
];
